import { UseFormReturnType } from '@mantine/form';
import React, { createContext, useContext } from 'react';
import { DynamicUiData, FormValuesType, UiItem, UiSection } from './types';

export interface DynamicUiContextType {
  form: UseFormReturnType<FormValuesType>;
  uiData: DynamicUiData;
  isEditable: boolean;
  isEditing: boolean;
  isCreateMode: boolean;
  setIsEditing: (editing: boolean) => void;
  toggleEditing: () => void;
  isDeletable: boolean;
  onDelete?: () => void;
  items?: UiItem[];
  renderUiEntityTitle?: (uiSection: UiSection) => React.ReactNode;
  clientId: string | undefined;
}

export const DynamicUiContext = createContext<DynamicUiContextType>({} as DynamicUiContextType);

export function useDynamicUI(): DynamicUiContextType {
  const context = useContext(DynamicUiContext);
  if (!context) {
    throw new Error('useDynamicUI must be used within a DynamicUiProvider');
  }
  return context;
}
